import { Combobox as ComboboxPrimitive } from '@base-ui/react';
import { useRef } from 'react';

export const useComboboxAnchor = () => {
  return useRef<HTMLDivElement | null>(null);
};

export const useComboboxFilter = ComboboxPrimitive.useFilter;
export const useComboboxFilteredItems = ComboboxPrimitive.useFilteredItems;
